<script>
    import _ from 'lodash'
    import moment from 'moment'
    import TimeUtils from '@/utils/time'
    import FollowupService from '@/request/followup/followup'
    import FollowupRecordService from '@/request/followup/followupRecord'
    import FollowupRecordGradeService from '@/request/followup/followupRecordGrade'
    import {CommentsItem, ReplyItem} from '@/components/EberComments'
    export default {
        name: 'FollowupListComments',
        components: {
            CommentsItem,
            ReplyItem
        },
        props: {
            rid: {
                type: Number,
                default: 0
            }
        },
        data () {
            return {
                followups: [],
                followupRecord: {},
                followupRecordGrade: {},
                currentFollowup: {},
                currentFollowupRecord: {},
                visibleEditRecord: false
            }
        },
        computed: {},
        created: function () {
            this.listFollowup()
            this.listRollowupRecord()
        },
        watch: {
            rid () {
                this.listFollowup()
                this.listRollowupRecord()
            },
            followups () {
                this.listRollowupRecord()
            }
        },
        methods: {
            listFollowup () {
                this.list = []
                if (!this.rid) {
                    return
                }
                FollowupService.list({
                    diseaseRecordId: this.rid
                }).then(data => {
                    this.followups = data ? _.sortBy(data.result, [function (o) { return o.num }]) : []
                })
            },
            listRollowupRecord () {
                let self = this
                if (!self.followups || self.followups.length <= 0) {
                    return
                }
                self.followupRecord = {}
                _.forEach(self.followups, value => {
                    FollowupRecordService.listRecord({
                        fuid: value.id
                    }).then(record => {
                        record = record.result || []
                        self.$set(self.followupRecord, value.id, record)
                        if (self.followupRecord[value.id].length > 0) {
                            _.forEach(self.followupRecord[value.id], fr => {
                                self.listFollowupRecordGrade(fr.id)
                            })
                        }
                    })
                })
            },
            listFollowupRecordGrade (record) {
                let self = this
                if (!record) {
                    return
                }
                FollowupRecordGradeService.list({
                    record: record
                }).then(data => {
                    data = data.result
                    if (data && data.length > 0) {
                        _.forEach(data, value => {
                            if (!self.followupRecordGrade[value.record]) {
                                self.$set(self.followupRecordGrade, value.record, {})
                            }
                            let grades = self.followupRecordGrade[value.record]['grades']
                            let gnames = self.followupRecordGrade[value.record]['gnames']
                            if (!grades) {
                                grades = []
                            }
                            if (!gnames) {
                                gnames = []
                            }
                            if (_.findIndex(grades, function (o) { return o.id === value.id }) < 0) {
                                grades.push(value)
                            }
                            if (_.indexOf(gnames, value.gname) < 0) {
                                gnames.push(value.gname)
                            }
                            self.$set(self.followupRecordGrade[value.record], 'grades', _.cloneDeep(grades))
                            self.$set(self.followupRecordGrade[value.record], 'gnames', _.cloneDeep(gnames))
                        })
                    }
                })
            },
            followupStateColor (state) {
                let bgcolor = '#409EFF'
                let textcolor = '#F2F6FC'
                switch (state) {
                    case 0:
                        bgcolor = '#409EFF'
                        textcolor = '#F2F6FC'
                        break
                    case 1:
                        bgcolor = '#909399'
                        textcolor = '#F2F6FC'
                        break
                    case 2:
                        bgcolor = '#67C23A'
                        textcolor = '#F2F6FC'
                        break
                    case 3:
                        bgcolor = '#F56C6C'
                        textcolor = '#F2F6FC'
                        break
                    case 4:
                        bgcolor = '#E6A23C'
                        textcolor = '#F2F6FC'
                        break
                    case 5:
                        bgcolor = '#67C23A'
                        textcolor = '#F2F6FC'
                        break
                }
                return {
                    background: bgcolor,
                    color: textcolor,
                    fontSize: '16px'
                }
            },
            replyTools(item) {
                if (!item) {
                    return [];
                }
                if (!item.regid || !this.$store.getters.user || this.$store.getters.user.id !== item.regid) {
                    return [];
                }
                let ts = [{
                    name: 'edit_frecord',
                    icon: 'el-icon-edit-outline',
                    title: '修改',
                    obj: item
                }/* , {
                    name: 'delete_frecord',
                    icon: 'el-icon-delete',
                    title: '删除',
                    style: {
                    color: '#F56C6C'
                    },
                    obj: item
                } */]
                return ts
            },
            handleClickReplyTool(tool) {
                if (!tool || !tool.name || !tool.obj) {
                    return
                }
                const frecord = tool.obj;
                if (tool.name === 'edit_frecord') {
                    this.handleUpdateFollowupRecord(frecord)
                }
                /* if (tool.name === 'delete_frecord') {
                    console.log('删除记录,id:' + frecord.id + '[等待删除接口]')
                } */
            },
            handleAddFollowupRecord (item) {
                this.currentFollowup = _.cloneDeep(item || {})
                this.visibleEditRecord = true
            },
            handleUpdateFollowupRecord (frecord) {
                this.currentFollowupRecord = _.cloneDeep(frecord);
                let i = _.findIndex(this.followups, o => { return o.id === frecord.fuid; });
                this.currentFollowup = _.cloneDeep(this.followups[i] || {})
                this.visibleEditRecord = true
            },
            handleSaveRecordDone () {
                this.listRollowupRecord()
                this.visibleEditRecord = false
            }
        },
        filters: {
            formatFollowupTime (value, startTime) {
                if (!value || !startTime || value === '未设时间') {
                    return '未设时间'
                }
                let duration = TimeUtils.timeToDuration(startTime, value)
                duration = moment(duration).startOf('day')
                let zero = moment(0).startOf('day')
                let years = duration.diff(zero, 'years', true)
                let months = duration.diff(zero, 'months', true)
                let weeks = duration.diff(zero, 'weeks', true)
                let days = duration.diff(zero, 'days', true)
                let mills = duration.diff(zero)
                let ago = ''
                if (_.isInteger(years)) {
                    ago = years + '年后'
                } else if (_.isInteger(months)) {
                    ago = months + '月后'
                } else if (_.isInteger(weeks)) {
                    ago = weeks + '周后'
                } else if (_.isInteger(days)) {
                    ago = days + '天后'
                } else {
                    ago = _.toInteger(mills / 1000) + '秒后'
                }
                return ago + '(' + moment(value).format('YYYY-MM-DD HH:mm:ss') + ')'
            },
            formatFollowupGrade (value) {
                let result = '未知'
                switch (value) {
                    case 1:
                        result = '良好'
                        break
                    case 2:
                        result = '一般'
                        break
                    case 3:
                        result = '不良'
                        break
                }
                return result
            }
        }
    }
</script>

<template>
    <div>
        <comments-item
                v-for="followup in followups"
                :avatar="followup.num"
                :avatar-style="followupStateColor(followup.state)"
                :key="followup.id"
                :author="followup.label"
                :time="followup.time | formatFollowupTime(followup.startTime)"
                :reply-text="'记录'"
                :has-reply="followupRecord[followup.id] && followupRecord[followup.id].length > 0"
                @addReply="handleAddFollowupRecord(followup)">
            <template slot="content">
                {{followup.inquiry}}
            </template>
            <reply-item
                    v-for="frecord in followupRecord[followup.id]"
                    :key="frecord.id"
                    :author="frecord.registrar"
                    :time="frecord.time"
                    :tools="replyTools(frecord)"
                    @clickTool="handleClickReplyTool">
                {{frecord.content}}
                <div class="frgrade-wrap" v-if="!!followupRecordGrade[frecord.id] && !!followupRecordGrade[frecord.id]['grades'] && followupRecordGrade[frecord.id]['grades'].length > 0">
                    <el-row :gutter="10" v-for="gname in followupRecordGrade[frecord.id]['gnames']" :key="gname" class="frgrade-row">
                        <el-col :span="3">
                            <span class="frgrade-gname">{{gname}}</span>
                        </el-col>
                        <el-col :span="21">
                            <template v-for="grade in followupRecordGrade[frecord.id]['grades']">
                                <span v-if="grade.gname === gname" :key="grade.id" class="frgrade-item">
                                    <span>{{grade.pname}}</span>
                                    <span class="frgrade-grade" :class="{warning: grade.grade === 2, danger: grade.grade === 3}">{{grade.grade | formatFollowupGrade}}</span>
                                </span>
                            </template>
                        </el-col>
                    </el-row>
                </div>
            </reply-item>
        </comments-item>
        <!-- 记录随访 -->
        <el-dialog title="随访" :visible.sync="visibleEditRecord" @close="currentFollowup = {}; currentFollowupRecord = {}" :close-on-click-modal="false">
            <followup-record-edit ref="recordEditRef" :followup="currentFollowup" :frecord="currentFollowupRecord" @saveDone="handleSaveRecordDone"></followup-record-edit>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visibleEditRecord = false">取 消</el-button>
                <el-button type="primary" @click="$refs['recordEditRef'].save()">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .frgrade-wrap {
        margin: 10px 0;
    }
    .frgrade-row {
        margin: 10px 0 0 0;
    }
    .frgrade-gname {
        font-weight: bold;
    }
    .frgrade-item {
        padding: 0 10px;
    }
    .frgrade-item .frgrade-grade {
        color: #67C23A;
    }
    .frgrade-item .frgrade-grade.warning {
        color: #E6A23C;
    }
    .frgrade-item .frgrade-grade.danger {
        color: #F56C6C;
    }
</style>
